



















































import { Component, Prop, Vue } from 'vue-property-decorator';

import { InputFile as InputFileInterface } from '@/lib/formFactory/input.interface';
import ButtonDefault from '@/components/BtnDefault.vue';

@Component({
    components: { ButtonDefault },
})
export default class InputFile extends Vue {
    @Prop({}) value?: { name: string };
    @Prop({}) data?: InputFileInterface;
    @Prop({ default: () => '' }) readonly error!: string;
    @Prop({}) disabled?: boolean;

    get isErrors() {
        return this.error.length > 0;
    }

    openModal() {
        (this.$refs.input as HTMLElement).click();
    }

    onChange(e: any) {
        if (!(e && e.target.files)) {
            return;
        }

        const file = e.target.files[0];

        this.$emit('change', file);
    }

    clear() {
        this.$emit('change', null);
    }
}
